
















import { Component, Vue, Watch, Prop } from "vue-property-decorator";
import { MapStoreModule } from "@/store/modules/mapStore";
import { prepareProjectTypes } from "@/utils/request";
import axios from "axios";
import {MessageModule} from "@/store/modules/messageModule";

@Component
export default class ProjectTypes extends Vue {
  @Prop() configs!: any;
  private projects = null;

  get availableStores() {
    return MapStoreModule.stores;
  }

  get existTypes(): boolean {
    if (this.projects) {
      return true
    }
    return false
  }

  protected async created(): Promise<any> {
    const requestConfig = prepareProjectTypes();
    const resultData = await axios(requestConfig);

    if (resultData.status == 200) {
       this.projects  = JSON.parse(resultData.data)

      // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
      // @ts-ignore
      if (this.projects.disable) {
        this.projects = null;
        return;
      }
      // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
      // @ts-ignore
      if (this.projects.error) {
        MapStoreModule.wasRequest(false);
        MapStoreModule.tooggleActive(false);
        MessageModule.showMessage({
          // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
          // @ts-ignore
          message: this.projects.msg
        });
        this.projects = null;
        return;
      }
    }
  }

  private changeProjectType(type: string) {
    const queryString = window.location.search
    // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
    // @ts-ignore
    const urlParams = new URLSearchParams(queryString);

    if (urlParams.get('type') === type) {
      return;
    }
    const nextURL = window.location.origin + window.location.pathname + '?type=' + type
    const nextState = { additionalInformation: 'Updated the URL with type ' + type };
   //window.location.href = window.location.origin + window.location.pathname + '?type=' + type
    history.pushState(nextState, document.title, nextURL)
    MapStoreModule.tooggleActive(false);
    MapStoreModule.tooggleError(false);
    MapStoreModule.wasRequest(false);

    if (!MapStoreModule.activeZip.match(/(^\d{5})(-\d{4})?$/)) {
      return
    }
    setTimeout(() => {
      if (this.availableStores) {
        MapStoreModule.dataRequest(MapStoreModule.activeZip);
      }
    }, 300)
  }

}
